import React from 'react';
import { Bold, Italic, List, ListOrdered, Underline, AlignLeft, AlignCenter, AlignRight, Link, Quote, Image, Palette } from 'lucide-react';
import { Button } from './Button';

const Toolbar = ({ editor }) => {
    if (!editor) {
        return null;
    }

    const toggleLink = () => {
        if (editor.isActive('link')) {
            editor.chain().focus().unsetLink().run();
            return;
        }
        const url = prompt('URL:');
        if (url === null) return;
        if (url === '') {
            editor.chain().focus().extendMarkRange('link').unsetLink().run();
            return;
        }
        editor.chain().focus().extendMarkRange('link').setLink({ href: url, target: '_blank' }).run();
    };

    const addImage = () => {
        const url = prompt('URL da Imagem:');
        if (url) {
            editor.chain().focus().setImage({ src: url }).run();
        }
    };

    return (
        <div className="flex flex-wrap items-center gap-1 p-2 border-b bg-muted/30">
            <Button
                type="button"
                onClick={() => editor.chain().focus().toggleBold().run()}
                disabled={!editor.can().chain().focus().toggleBold().run()}
                variant={editor.isActive('bold') ? 'default' : 'outline'}
                size="icon"
                title="Negrito"
            >
                <Bold className="h-4 w-4" />
            </Button>
            <Button
                type="button"
                onClick={() => editor.chain().focus().toggleItalic().run()}
                disabled={!editor.can().chain().focus().toggleItalic().run()}
                variant={editor.isActive('italic') ? 'default' : 'outline'}
                size="icon"
                title="Itálico"
            >
                <Italic className="h-4 w-4" />
            </Button>
            <Button
                type="button"
                onClick={() => editor.chain().focus().toggleUnderline().run()}
                variant={editor.isActive('underline') ? 'default' : 'outline'}
                size="icon"
                title="Sublinhado"
            >
                <Underline className="h-4 w-4" />
            </Button>
            <Button
                type="button"
                onClick={() => editor.chain().focus().toggleBlockquote().run()}
                variant={editor.isActive('blockquote') ? 'default' : 'outline'}
                size="icon"
                title="Citação"
            >
                <Quote className="h-4 w-4" />
            </Button>
            
            <div className="h-6 w-px bg-border mx-1" />

            <Button
                type="button"
                onClick={() => editor.chain().focus().toggleBulletList().run()}
                variant={editor.isActive('bulletList') ? 'default' : 'outline'}
                size="icon"
                title="Lista Não Ordenada"
            >
                <List className="h-4 w-4" />
            </Button>
            <Button
                type="button"
                onClick={() => editor.chain().focus().toggleOrderedList().run()}
                variant={editor.isActive('orderedList') ? 'default' : 'outline'}
                size="icon"
                title="Lista Ordenada"
            >
                <ListOrdered className="h-4 w-4" />
            </Button>

            <div className="h-6 w-px bg-border mx-1" />

            <input
                type="color"
                onInput={event => editor.chain().focus().setColor(event.target.value).run()}
                value={editor.getAttributes('textStyle').color || '#000000'}
                className="h-8 w-8 p-0 border-none cursor-pointer rounded-md overflow-hidden"
                title="Cor do Texto"
            />
            <Button
                type="button"
                onClick={() => editor.chain().focus().unsetColor().run()}
                variant="outline"
                size="icon"
                title="Remover Cor"
            >
                <Palette className="h-4 w-4" />
            </Button>

            <div className="h-6 w-px bg-border mx-1" />

            <Button
                type="button"
                onClick={addImage}
                variant="outline"
                size="icon"
                title="Adicionar Imagem"
            >
                <Image className="h-4 w-4" />
            </Button>

            <div className="h-6 w-px bg-border mx-1" />

            <Button
                type="button"
                onClick={() => editor.chain().focus().setTextAlign('left').run()}
                variant={editor.isActive({ textAlign: 'left' }) ? 'default' : 'outline'}
                size="icon"
                title="Alinhar à Esquerda"
            >
                <AlignLeft className="h-4 w-4" />
            </Button>
            <Button
                type="button"
                onClick={() => editor.chain().focus().setTextAlign('center').run()}
                variant={editor.isActive({ textAlign: 'center' }) ? 'default' : 'outline'}
                size="icon"
                title="Alinhar ao Centro"
            >
                <AlignCenter className="h-4 w-4" />
            </Button>
            <Button
                type="button"
                onClick={() => editor.chain().focus().setTextAlign('right').run()}
                variant={editor.isActive({ textAlign: 'right' }) ? 'default' : 'outline'}
                size="icon"
                title="Alinhar à Direita"
            >
                <AlignRight className="h-4 w-4" />
            </Button>

            <div className="h-6 w-px bg-border mx-1" />

            <Button
                type="button"
                onClick={toggleLink}
                variant={editor.isActive('link') ? 'default' : 'outline'}
                size="icon"
                title="Link"
            >
                <Link className="h-4 w-4" />
            </Button>
        </div>
    );
};

export default Toolbar;